import { render, staticRenderFns } from "./ClientScores.vue?vue&type=template&id=3f1d4dd7&"
import script from "./ClientScores.vue?vue&type=script&lang=js&"
export * from "./ClientScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports